<template>
  <div class="content">
    <div class="container-fluid">

      <!-- Mail Statics Card-->
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-chart text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">Toplam Mail Sayısı</p>
              <h4 class="card-title">{{ basicStats.totalMailCount }}</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-light-3 text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Kuyrukta</p>
              <h4 class="card-title">{{ basicStats.pendingCount }}</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-vector text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-category">Gönderildi</p>
              <h4 class="card-title">{{ basicStats.sendedCount + basicStats.openedCount }}</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-info">
              <i class="nc-icon nc-favourite-28 text-primary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Açıldı</p>
              <h4 class="card-title">{{ basicStats.openedCount }}</h4>
            </div>
          </stats-card>
        </div>

      </div>



      <!-- Company and search Machine Statics Card-->
      <div v-if="companyMetrics" class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-bag text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">Kayıtlı Şirket Sayısı</p>
              <h4 class="card-title">{{ companyMetrics.totalCompanies }}</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-settings-gear-64 text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Şirketlerin Aradığı Makine Sayısı</p>
              <h4 class="card-title">{{ companyMetrics.totalSearchingMachines }}</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-settings-gear-64 text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-category">Şirketlerin Elindeki Makine Sayısı</p>
              <h4 class="card-title">{{ companyMetrics.totalOwnMachines }}</h4>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-info">
              <i class="nc-icon nc-spaceship text-primary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Potansiyel Eşleşen Ticaret</p>
              <h4 class="card-title">{{ potentialTradeCount }}</h4>
            </div>
          </stats-card>
        </div>

      </div>

      <!-- Mail Chart-->
      <div class="row" style="font-family: 'FontAwesome' !important;">
        <div class="col-md-8" v-if="lineChartRender">
          <chart-card :chart-data="lineChart.data" :chart-options="lineChart.options" ref="lineChart"
            :responsive-options="lineChart.responsiveOptions">
            <template slot="header">
              <h4 class="card-title">Gönderilen Mailler</h4>
              <p class="card-category">1 Haftalık Performans</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <span v-for="template of Object.values(templates)"> <br><i class="fa fa-circle "></i>
                  {{ template }}</span>

              </div>
              <hr>
            </template>
          </chart-card>
        </div>

        <div v-if="pieChartRender" class="col-md-4">
          <chart-card :chart-data="pieChart.data" chart-type="Pie" :ref="pieChart">
            <template slot="header">
              <h4 class="card-title">Email İstatistikleri</h4>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Aktif
                <i class="fa fa-circle text-danger"></i> Pasif(Abone Değil + Pasif)
              </div>
              <hr>
            </template>
          </chart-card>
        </div>


      </div>


    </div>
  </div>
</template>
<script>
import ChartCard from 'src/components/Cards/ChartCard.vue'
import StatsCard from 'src/components/Cards/StatsCard.vue'
import LTable from 'src/components/Table.vue'
import CollectionService from "../services/collection.service.js";

export default {
  components: {
    LTable,
    ChartCard,
    StatsCard
  },
  mounted() {
    this.getBasicStats();
    this.getSendMailByDate();
    this.getCompanyMetrics();
  },
  data() {
    return {
      pieChartRender: false,
      lineChartRender: false,
      basicStats: {
        "totalMailCount": 0,
        "activeMailCount": 0,
        "passiveMailCount": 0,
        "pendingCount": 0,
        "sendedCount": 0,
        "openedCount": 0
      },
      sendMailByDate: {},
      templates: {},
      editTooltip: 'Edit Task',
      deleteTooltip: 'Remove',
      pieChart: {
        data: {
          labels: ['90%', '10%'],
          series: [90, 10]
        }
      },
      lineChart: {
        data: {
          labels: ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'],
          series: [
            [1000, 250, 0, 0, 0, 0, 0],
            [0, 0, 0, 600, 600, 700, 0],
            [0, 0, 0, 0, 0, 0, 1200]
          ]
        },
        options: {
          low: 0,
          high: 4000,
          showArea: false,
          height: '245px',
          axisX: {
            showGrid: false
          },
          lineSmooth: true,
          showLine: true,
          showPoint: true,
          fullWidth: true,
          chartPadding: {
            right: 50
          }
        },
        responsiveOptions: [
          ['screen and (max-width: 640px)', {
            axisX: {
              labelInterpolationFnc(value) {
                return value[0]
              }
            }
          }]
        ],
      },
      companyMetrics: { totalCompanies: 0, totalSearchingMachines: 0, totalOwnMachines: 0 },
      potentialTradeCount: 0

    }
  },
  methods: {
    getBasicStats() {
      CollectionService.getCollection('overview/mailstats', '').then((res) => {
        if (res.success == true) {
          this.basicStats = res.data;
          this.initPieChart()
        } else {
          console.log('error');
        }
      })
    },
    getCompanyMetrics() {
      CollectionService.getCollection('overview/companymetrics', '').then((res) => {
        if (res.success == true) {
          this.companyMetrics = res.data.metrics;
        } else {
          console.log('error');
        }
      })
    },
    getSendMailByDate() {
      CollectionService.getCollection('overview/sendmailbydate', '').then((res) => {
        if (res.success == true) {
          this.sendMailByDate = res.data;
          this.templates = res.templates;
          this.initLineChart()
        } else {
          console.log('error');
        }
      })
    },
    initPieChart() {
      let chartData = {

        labels: [`${((this.basicStats.activeMailCount / this.basicStats.totalMailCount) * 100).toFixed(2)}%`, `${((this.basicStats.passiveMailCount / this.basicStats.totalMailCount) * 100).toFixed(2)}%`],
        series: [this.basicStats.activeMailCount, this.basicStats.passiveMailCount]
      }

      console.log(chartData);
      this.pieChart.data = chartData;
      this.pieChartRender = true;
    },
    initLineChart() {
      var labels = this.getLastDaysNamesForLabel(7);
      var high = 7;
      const series = Object.values(this.sendMailByDate).map(x => {
        if (Object.values(x).sort((a, b) => b - a)[0] > high);
        high = Object.values(x).sort((a, b) => b - a)[0];
        return Object.values(x)
      });
      let chartData = {
        labels: labels.map(x => x.text),
        series
      }
      this.lineChart.data = chartData;
      this.lineChart.options.high = high;
      this.lineChartRender = true;
    },
    getLastDaysNamesForLabel(range) {
      var tour = (range / 7) + 3;
      var currentTimeStamp = new Date().getTime();
      let arr = [], i;
      var dayNames = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar']

      for (i = 0; i < range; i++) {
        var day = new Date(currentTimeStamp).getDay();
        var date = new Date(currentTimeStamp).getDate();
        arr.push({ val: String(new Date(currentTimeStamp).getMonth()) + date, text: dayNames[day + 6] })
        currentTimeStamp -= 1000 * 60 * 60 * 24
      }
      arr[0].text = arr[0].text
      return arr.reverse();
    },
  }
}
</script>
<style></style>